export const ReduxKEY = "redux";

export function loadState(key) {
    return loadData(key)
}

export async function saveState(state, key) {
    saveData(state, key)
}

function loadData(key) {
    try {
        const serializedState = localStorage.getItem(key);
        if (!serializedState) return "NOSTATE";
        return JSON.parse(serializedState);
    } catch (e) {
        return "errror";
    }
}

export async function saveData(state, key) {
    try {
        if(state.auth.user !== null){
            const serializedState = JSON.stringify(state);
            localStorage.setItem(key, serializedState);
        }
    } catch (e) {
        // Ignore
    }
}

export const removeLocalStorage = () => {
    localStorage.removeItem(ReduxKEY);
}

export const debounce = (func, delay) => {
    let inDebounce
    return function () {
        const context = this
        const args = arguments
        clearTimeout(inDebounce)
        inDebounce = setTimeout(() => func.apply(context, args), delay)
    }
}
